import { AbstractContentState, useCmsContent } from '@cp-shared-15/frontend-integration';
import { ErrorPage } from 'cpie-common';
import { fetchNotFoundErrorPage } from './NotFoundErrorPageSlice';
import { NotFoundErrorPageContentSelector } from './NotFoundErrorPageContentSelector';

export function useNotFoundErrorPage(): AbstractContentState<ErrorPage> {
    return useCmsContent(fetchNotFoundErrorPage, NotFoundErrorPageContentSelector);
}
